import type { ReactNode, FC } from "react";
import { createContext, use } from "react";

export type RegistrationVariant = "Controller" | "Processor";

const Context = createContext<RegistrationVariant | undefined>(undefined);

type RegistrationVariantProviderProps = { children: ReactNode; variant: RegistrationVariant };

export const RegistrationVariantProvider: FC<RegistrationVariantProviderProps> = ({ variant, children }) => {
  return <Context value={variant}>{children}</Context>;
};

export const useRegistrationVariant = () => {
  const context = use(Context);
  if (!context) throw new Error('"useRegistrationVariant" can only be used within a "RegistrationVariantProvider" ');

  return context;
};
